import React from 'react'

const BkFlowStructuredSidebarAmenities = props => {
	const {
		configData,
		propertyAmenities,
	} = props

	const hotelLabels = configData.hotel.labels[0]
	let amenitiesEntries = []

	for (const amenityKey in propertyAmenities) {
		const currentAmenity = propertyAmenities[amenityKey]

		if (currentAmenity.name) {
			amenitiesEntries.push(
				<li
					key={'sidebar-amenity-' + amenityKey}
				>
					{currentAmenity.name}
				</li>
			)
		}
	}

	return (
		<div className="bk-flow-structured-sidebar__amenities">
			<h6>{ hotelLabels.sidebarAmenitiesTitle ? hotelLabels.sidebarAmenitiesTitle : 'Property Amenities' }</h6>
			<ul>
				{ amenitiesEntries }
			</ul>
		</div>
	)
}



export default BkFlowStructuredSidebarAmenities


// WEBPACK FOOTER //
// ./src/components/structure/sidebar/BkFlowStructuredSidebarAmenities.js